import VehicleImage from './VehicleImage';
import { Reveal } from './Reveal';
import { EXPERIENCE } from '../data/content';

const Experience = () => (
  <section id="experience" data-testid="experience-section" className="scroll-mt-24 border-y border-white/5 bg-[#0a0a0a] py-28 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="mb-20 md:mb-28">
        <Reveal>
          <span className="text-xs font-medium uppercase tracking-[0.35em] text-gold">The Experience</span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display mt-4 max-w-3xl text-4xl leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-7xl">
            Drive Beyond <span className="italic text-gold">Ordinary.</span>
          </h2>
        </Reveal>
      </div>

      <div className="flex flex-col gap-24 md:gap-32">
        {EXPERIENCE.map((c, i) => (
          <div
            key={c.chapter}
            data-testid={`experience-chapter-${c.chapter}`}
            className={`grid items-center gap-10 md:grid-cols-12 md:gap-0 ${i % 2 === 1 ? '' : ''}`}
          >
            <Reveal className={`md:col-span-7 ${i % 2 === 1 ? 'md:order-2' : ''}`} y={30}>
              <div className="group relative overflow-hidden border border-white/5">
                <div className="aspect-[16/10]">
                  <VehicleImage src={c.image} alt={c.title} label={`CHAPTER ${c.chapter}`} />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-ink/50 to-transparent" />
              </div>
            </Reveal>
            <div className={`relative md:col-span-5 ${i % 2 === 1 ? 'md:order-1 md:pr-16' : 'md:pl-16'}`}>
              <Reveal delay={0.15}>
                <span className="outline-text-gold font-display block text-7xl leading-none lg:text-8xl">{c.chapter}</span>
                <h3 className="font-display mt-6 text-3xl tracking-tight text-white lg:text-4xl">{c.title}</h3>
                <p className="mt-5 max-w-md text-base font-light leading-relaxed text-white/55">{c.text}</p>
                <div className="mt-7 h-px w-16 bg-gold/50" />
              </Reveal>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Experience;
